import { Suspense, useEffect, useState } from 'react'
import { ModalContext } from '@nv/contexts'
import Modal from 'react-modal'
import { ModalFooter } from '../components/modal_footer/ModalFooter'
import { ModalHeader } from '../components/modal_header/ModalHeader'
import styles from './NVModal.module.scss'

const modalStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    borderRadius: '0.75rem',
    padding: 0,
    overflowY: 'scroll',
    maxHeight: 'calc(100% - 1.25rem)',
  },
  overlay: {
    background: 'rgba(0, 0, 0, 0.5)',
    zIndex: 3,
    overflowY: 'scroll',
  },
}

export const NVModal = ({ isOpen = false, onClose, children }: any) => {
  const [headerLabel, setHeaderLabel] = useState()
  const [btns, setBtns] = useState()

  useEffect(() => {
    Modal.setAppElement('#root')
  }, [])

  return (
    <ModalContext.Provider
      value={{
        setHeaderLabel,
        setBtns,
        onClose,
      }}
    >
      <Modal ariaHideApp={false} isOpen={isOpen} onRequestClose={onClose} style={modalStyles}>
        <div className={styles['container']}>
          <ModalHeader onClose={onClose} label={headerLabel} />
          <Suspense fallback={null}>
            <div className={styles['content']}>{children}</div>
          </Suspense>
          <ModalFooter btns={btns} />
        </div>
      </Modal>
    </ModalContext.Provider>
  )
}

export default NVModal
